class VeloraProductEvidence extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.carousel = this.querySelector('[data-lvpa-carousel]');
    this.current = this.querySelector('[data-lvpa-current]');
    this.previous = this.querySelector('[data-lvpa-prev]');
    this.next = this.querySelector('[data-lvpa-next]');

    if (this.carousel && this.current) {
      const cards = [...this.carousel.querySelectorAll('[data-lvpa-card]')];
      if (!cards.length) return;
      const total = this.querySelector('[data-lvpa-total]');
      if (total) total.textContent = String(cards.length).padStart(2, '0');
      const currentIndex = () => {
        const end = this.carousel.scrollWidth - this.carousel.clientWidth;
        if (end > 0 && this.carousel.scrollLeft >= end - 2) return cards.length - 1;
        const left = this.carousel.getBoundingClientRect().left;
        return cards.reduce((best, card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - left);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Infinity }).index;
      };
      const update = () => {
        const index = currentIndex();
        this.current.textContent = String(index + 1).padStart(2, '0');
        if (this.previous) this.previous.disabled = index === 0;
        if (this.next) this.next.disabled = index === cards.length - 1;
      };
      const move = (direction) => {
        const target = cards[Math.max(0, Math.min(cards.length - 1, currentIndex() + direction))];
        if (!target) return;
        this.carousel.scrollTo({
          left: target.offsetLeft - cards[0].offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      };
      this.previous?.addEventListener('click', () => move(-1));
      this.next?.addEventListener('click', () => move(1));
      let scheduled = false;
      this.carousel.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          update();
          scheduled = false;
        });
      }, { passive: true });
      this.carousel.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      update();
    }
  }
}

if (!customElements.get('velora-product-evidence')) {
  customElements.define('velora-product-evidence', VeloraProductEvidence);
}
